import { render, staticRenderFns } from "./NotificationBanner.html?vue&type=template&id=89f18cf6&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBanner.scss?vue&type=style&index=0&id=89f18cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f18cf6",
  null
  
)

export default component.exports